import { api } from "./api";
import {
  MonthlyOverviewDetailsResponse,
  MonthlyOverviewMetricKey,
  MonthlyOverviewResponse,
} from "../types/monthlyOverview.type";

/**
 * Получить агрегированную статистику за выбранный месяц.
 * Все вычисления выполняются на стороне сервера.
 *
 * @param month Месяц (1-12)
 * @param year  Год (YYYY)
 */
export const getMonthlyOverview = async (
  month: number,
  year: number
): Promise<MonthlyOverviewResponse> => {
  const response = await api.get<MonthlyOverviewResponse>("/monthly-overview", {
    params: { month, year },
  });
  return response.data;
};

/**
 * Получить расшифровку («откуда пришла цифра») одной метрики за месяц.
 *
 * @param metric Ключ метрики
 * @param month  Месяц (1-12)
 * @param year   Год (YYYY)
 */
export const getMonthlyOverviewDetails = async (
  metric: MonthlyOverviewMetricKey,
  month: number,
  year: number
): Promise<MonthlyOverviewDetailsResponse> => {
  const response = await api.get<MonthlyOverviewDetailsResponse>(
    "/monthly-overview/details",
    { params: { metric, month, year } }
  );
  return response.data;
};
